const Raven = require('raven-js');
const clientConfig = Raven.config(process.env.SENTRY_DSN, {
    logger: 'client',
    node_end: process.env.NODE_ENV,
    mgc_env: process.env.MGC_ENV,
    api_url: process.env.API_URL,
});
let client = null;
const SENTRY_ENABLED =
    process.env.SENTRY_ENABLED && process.env.SENTRY_ENABLED !== 'false';

if (SENTRY_ENABLED) {
    client = clientConfig.install();
}

export function logException(e, context = {}) {
    if (SENTRY_ENABLED) {
        client.captureException(e, {
            extra: Object.assign({}, context, { _env: process.env }),
        });
    }
    /* eslint no-console:0*/
    console && console.error && console.error(e);
}

export default { logException };



// WEBPACK FOOTER //
// ./app/sentry.js